export default "__VITE_ASSET__OIjk7l7I__"